const CITY_CONNECTORS = new Set(["de", "da", "do", "das", "dos"]);

export function normalizeCityValue(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9\s/-]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function normalizeCityIdentity(value) {
  return normalizeCityValue(value)
    .split(/\s+/)
    .filter((token) => token && !CITY_CONNECTORS.has(token))
    .join(" ");
}
